export const filteringLogic = (filter, row) => {
    let value = row[filter.id];

    if (filter.id === 'id') value = value.toString();
    if (value === undefined || value === null) return false;
    if (typeof value === 'object') value = value[filter.id];

    if (filter.value.exact && filter.value.content !== '') {
        return value.toLowerCase() === filter.value.content.toLowerCase();
    }
    if (filter.value.multiChoice) {
        const filteredChoices = filter.value.content;

        return Object.keys(filteredChoices).every(choice =>
            !filteredChoices[choice] || value.includes(choice)
        );
    }
    if (filter.value.numeric) {
        if (filter.value.content === '') return true;
        return value.toString().includes(filter.value.content);
    }
    if (filter.value.filterDate) {
        const localDate = new Date(value).toLocaleString();
        return localDate.includes(filter.value.content);
    }

    return value.toLowerCase().replace(/[`~׳!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
        .includes(filter.value.content.toLowerCase().replace(/[`~׳!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
};

export const combineRestaurantsData = (restaurants, posSuppliers) => {
    return restaurants.map((rest) => {
        const inactive = !rest.supportTableOrderCode && !rest.supportCartFeatures && !rest.supportQuickPayment;
        const missingPosBranchId = rest.supportCartFeatures && rest.posSupplierId !== '1' && !rest.posBranchId;
        const posSupplier = (posSuppliers.find(pos => pos.id == rest.posSupplierId) || {}).name || '';

        return { ...rest, posSupplier, inactive, missingPosBranchId, supportKiosk: rest.activeKiosks > 0 };
    });
};

export const posConfigFactory = (value, posSuppliers) => {
    const selectedPosSupplier = posSuppliers.find(ps => ps.id == value);

    const posConfig = { posId: value, supplier: selectedPosSupplier.name };

    selectedPosSupplier.config.map(({ field, defaultValue }) => {
        if (defaultValue && !posConfig[field]) {
            posConfig[field] = defaultValue;
        }
    });

    return posConfig;
};

export const terminalConfigFactory = (value, paymentTerminals) => {
    const selectedTerminal = paymentTerminals.find(pt => pt.terminalType == value);

    const terminalConfig = { terminalType: value };

    selectedTerminal.config.map(({ field, defaultValue }) => {
        if (!terminalConfig[field]) {
            terminalConfig[field] = defaultValue;
        }
    });

    return terminalConfig;
};